import { render } from "./add.vue?vue&type=template&id=47ee7a75&ts=true"
import script from "./add.vue?vue&type=script&lang=ts"
export * from "./add.vue?vue&type=script&lang=ts"

import "./add.vue?vue&type=style&index=0&id=47ee7a75&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__